var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpecialNeeds = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 4H5a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h13v2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M24.35 21.008c3.576-1.808 7.132 2.687 4.42 5.764h-.001l-3.68 4.16-.004.005a2.912 2.912 0 0 1-4.34 0l-.004-.004-3.382-3.823h-.01l-.297-.337c-2.735-3.086.843-7.566 4.417-5.766l.17.09.002.002 1.27.712 1.269-.712zm-3.689 1.834c-1.638-.917-3.269 1.05-2.224 2.469l3.798 4.293.072.07a.91.91 0 0 0 1.288-.07l3.675-4.157c1.224-1.39-.338-3.412-1.954-2.684l-.156.079-1.76.99-.49.275z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.91 22.1h-4v-2h4zM27 2a3 3 0 0 1 3 3v15h-2V5a1 1 0 0 0-1-1h-1V2zM18.83 17.1H7.91v-2h10.92zM21 12H8v-2h13zM8 0a1 1 0 0 1 1 1v4.13a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1M16 0a1 1 0 0 1 1 1v4.13a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1M24 0a1 1 0 0 1 1 1v4.13a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1M14 4h-4V2h4zM22 4h-4V2h4z"
})));
export default SvgSpecialNeeds;